module.exports = {"420325100":"城关镇","420325101":"军店镇","420325102":"化龙堰镇","420325103":"土城镇","420325104":"大木厂镇","420325105":"青峰镇","420325106":"门古寺镇","420325107":"白鹤镇","420325108":"野人谷镇","420325109":"红塔镇","420325110":"窑淮镇","420325111":"尹吉甫镇","420325203":"姚坪乡","420325205":"沙河乡","420325206":"万峪河乡","420325208":"上龛乡","420325209":"中坝乡","420325210":"九道乡","420325211":"回龙乡","420325212":"五台乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420325.json
// module id = 1723
// module chunks = 0